import { cva } from "../../../../node_modules/.pnpm/class-variance-authority@0.7.1/node_modules/class-variance-authority/dist/index.js";
const itemVariants = cva(null, {
  variants: {
    layout: {
      vertical: "mb-2",
      horizontal: "",
      inline: "inline-block mr-2"
    }
  },
  defaultVariants: {
    layout: "vertical"
  }
}), componentVariants = cva(null, {
  variants: {
    layout: {
      vertical: "",
      horizontal: "",
      inline: ""
    }
  },
  compoundVariants: [
    { layout: ["horizontal", "inline"], class: "flex mb-2" }
  ],
  defaultVariants: {
    layout: "vertical"
  }
}), formLabelVariants = cva(null, {
  variants: {
    layout: {
      vertical: "",
      horizontal: "",
      inline: ""
    }
  },
  compoundVariants: [
    { layout: ["horizontal", "inline"], class: "mr-2 max-h-9" }
  ],
  defaultVariants: {
    layout: "vertical"
  }
});
export {
  componentVariants,
  formLabelVariants,
  itemVariants
};
//# sourceMappingURL=variants.js.map
